<template>
  <div class="col-12 px-0">
    <NewsletterType
      :draft="draft"
      :newsletter-types="newsletterTypes"
      @clearedDraft="onClearedDraft"
    />

    <h2>Marketing</h2>

    <div class="form-group">
      <div class="d-flex justify-content-between">
        <label>Marketing introduction</label>

        <span :class="{ 'text-danger': (draft.steps.overview.introduction || '').replace(/(<([^>]+)>)/ig, '').length > 500 }">
          {{ (draft.steps.overview.introduction || '').length }}/500
        </span>
      </div>

      <HtmlEditor
        v-model="draft.steps.overview.introduction"
        :token="`Bearer ${$login.getToken()}`"
        :image-upload-url="imageUploadUrl"
        :file-upload-url="fileUploadUrl"
      />
    </div>
  </div>
</template>
<script>
import {HtmlEditor} from '@frontend/components'
import NewsletterType from '../Components/NewsletterType'

export default {
  name: 'DailyEquityNoteOverviewStep',

  components: {
    NewsletterType,
    HtmlEditor,
  },

  props: {
    draft: {
      type: Object,
      required: true,
    },
    newsletterTypes: {
      type: Array,
      required: true,
    },
  },

  metaInfo () {
    return {
      title: this.draft && this.draft.subject ? this.draft.subject : 'Create Newsletter',
    }
  },

  data () {
    return {
      newsletterType: this.newsletterTypes.find((t) => t.id === this.draft.newsletter_type_id),
      error: null,
      imageUploadUrl: process.env.VUE_APP_API_ENDPOINT + 'upload/image',
      fileUploadUrl: process.env.VUE_APP_API_ENDPOINT + 'upload/file'
    }
  },

  watch: {
    newsletterType (value) {
      this.draft.newsletter_type_id = value.id
    },
  },

  methods: {
    onClearedDraft (newDraft) {
      this.$emit('clearedDraft', newDraft)
    },
  },
}
</script>

<style scoped>
h2 {
  font-size: 21px;
  font-weight: normal;
  line-height: 1.14;
  letter-spacing: normal;
  margin-bottom: 32px;
}

.form-group {
  margin-bottom: 170px;
}
</style>
